import { ReactNode } from 'react';

import { ColumnConfiguration } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const { Grid } = ui;

const S9PageSection = ui.S9PageSection.default;

type Props = {
  queryVars: Record<string, number> | undefined;
  queryName: string;
  title: string;
  columns: ColumnConfiguration[];
  searchFields?: string[];
  showFilter?: boolean;
  children?: ReactNode;
};

export const ListTable = ({
  queryVars,
  queryName,
  title,
  columns,
  searchFields = [],
  showFilter = false,
  children,
}: Props) => (
  <S9PageSection title={title} size="sm">
    {children}
    <Grid
      name={queryName}
      columnsConfiguration={columns}
      querySearchFields={searchFields}
      showFilter={showFilter}
      searchQueryKey={queryName}
      queryVars={queryVars}
    />
  </S9PageSection>
);
